export default function FindingDocumentDirective() {
  return {
    template: require('./finding-document.html'),
    scope: {
      findingId: '=',
      canEdit: '=',
      canDelete: '=',
      findingDocument: '=',
    },
    controller: 'FindingDocumentController',
    controllerAs: 'findingDocumentVM',
    bindToController: true,
    replace: true
  };
}
